<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff">
      <el-card class="update-log">
        <div class="t-box mb20">
          <div class="flex_warp flex">
            <div class="f-box" v-for="(item, index) in list" @click="handleCheck(item)" :key="index"
              :class="item.stock == 0 ? 'bgeee' : ''">
              <div class="bold clamp2 plr10">{{ item.name }}</div>
              <div class="content flex_between flex plr10">
                <div>库存：{{ item.stock }}</div>
                <div class="red bold">￥{{ item.sale_price }}</div>
              </div>
            </div>
            <div v-if="list.length == 0" class="txt_center w100">暂无数据</div>
          </div>
        </div>
      </el-card>


    </div>


    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" ref="form"
      :title="handleItem ? handleItem.name : ''" :visible.sync="popShow" width="1000px" :modal-append-to-body='false'
      :append-to-body="true">
      <div class="flex">
        <div style="border-right: 1px solid #ccc;" class="pr20">
          <el-form :model="form" :rules="rules" ref="ticketForm" label-width="120px" label-position="right"
            class="ticket-form">
            <!-- <el-divider content-position="left">基本信息</el-divider> -->
            <!-- <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="购票人姓名">
                  <el-input placeholder="请输入" v-model="form.contacts" max="10"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购票人电话">
                  <el-input placeholder="请输入" v-model="form.contact_mobile" max="11"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="游客姓名" prop="tourist_name">
                  <el-input placeholder="请输入" v-model="form.tourist_name" max="10" required></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="游客电话" prop="tourist_phone">
                  <el-input placeholder="请输入" v-model="form.tourist_phone" max="11" required></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="证件类型" prop="tourist_certificate">
                  <el-select v-model="form.tourist_certificate" placeholder="请选择" required clearable
                    style="width: 100%">
                    <el-option v-for="(item, index) in tourist_certificate" :key="index" :label="item" :value="index" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证件号码" prop="tourist_code">
                  <el-input placeholder="请输入" v-model="form.tourist_code" max="25" required></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="备注" prop="备注">
                  <el-input placeholder="请输入" v-model="form.notes" max="11"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="证件号码" prop="tourist_code" required>
                  <el-input placeholder="请输入" v-model="form.tourist_code" max="25"></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>

          </el-form>


        </div>
        <div class="pl20" style="width:30%">
          <div>
            <div class="mb20">应付金额：<span class="red bold">￥{{ handleItem ? handleItem.sale_price : '' }}</span> </div>
            <el-radio-group v-model="form.payment_type" size="medium">
              <el-radio :label="item.key" class="flex flex_items mb20" v-for="item in pay_type" :key="item.key">
                <div class="flex flex_items">
                  <img :src="item.icon" class="icon"> {{ item.name }}
                </div>
              </el-radio>
            </el-radio-group>

            <div class="pos" :style="form.payment_type != 'offlinePayment' ? 'opacity:0' : ''">
              <div class="mask" v-if="form.payment_type != 'offlinePayment'"></div>
              <div class="flex flex_items mb20">
                <div class="flex_shrink mr10">实收</div>
                <el-input v-model="payMoney"></el-input>
              </div>
              <div class="flex flex_items mb20">
                <div class="flex_shrink mr10">找零</div>
                <el-input disabled v-model="zhaoling"></el-input>
              </div>
            </div>
          </div>
          <div class="flex mt20">
            <el-button @click="resetUser">重置</el-button>
            <el-button type="primary" style="width: 150px;" @click="subUser">提交</el-button>
          </div>
        </div>
      </div>
    </el-dialog>


    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="支付"
      :visible.sync="payPop" width="500px" :modal-append-to-body='false' :append-to-body="true">
      <div class="flex flex_items">
        <span class="flex_shrink">支付码：</span>
        <el-input v-model="auth_code" ref="myInput" @keyup.enter.native="payFn(1)"></el-input>
      </div>
      <div class="red mt10">若光标没有指入输入框请手动点击输入框后扫描支付码</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearCode">清空</el-button>
        <el-button type="primary" @click="payFn(1)">结账</el-button>
      </div>
    </el-dialog>


    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="查询支付状态"
      :visible.sync="nxCheckPop" width="500px" :modal-append-to-body='false' :append-to-body="true">
      <div class="flex flex_items">
        <el-button type="primary" @click="checkPayStatus" :loading="nxCheckPopLoading">
          {{ nxCheckPopLoading ? '查询中...' : '查询支付状态' }}</el-button>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="nxCheckPop = false">清空</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import { showZzToast } from '@/utils/index'
export default {
  data() {
    return {
      page: 1,
      list: [],
      popShow: false,
      form: {
        payment_type: '',
        contacts: '',
        contact_mobile: '',
        notes: '',
        year_card_id: '',
        tourist_name: '',
        tourist_phone: '',
        tourist_certificate: '',
        tourist_code: '',
      },
      tourist_certificate: [],
      handleItem: null,
      rules: {
        tourist_name: [{
          validator: (rule, value, callback) => {
            if (!value || value.length >= 10) {
              callback(new Error('请输入10字以内的游客姓名'));
            } else {
              callback();
            }
          }, trigger: ['blur']
        }],
        tourist_code: [
          { required: true, message: "证件号不能为空", trigger: "blur" },
          { min: 1, max: 30, message: "证件长度在1到30个字符", trigger: "blur" }
        ],
        tourist_phone: [
          {
            validator: (rule, value, callback) => {
              if (!/^1[2-9]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号'));
              } else {
                callback();
              }
            }, trigger: ['blur', 'change']
          }
        ],
      },
      pay_type: [],
      zhaoling: '',
      payMoney: '',
      orderId: '',
      payPop: false,
      auth_code: '',
      timer: null,
      timeFlag: 0,
      nxCheckPop: false,
      nxCheckPopLoading: false,
    };
  },
  watch: {
    payMoney(n) {
      this.zhaoling = n - this.handleItem.sale_price <= 0 ? 0 : (n - this.handleItem.sale_price).toFixed(2);
    }
  },
  methods: {
    goto(url) {
      this.$router.push(url)
    },
    getList() {
      this.api.getUrl(`/api/v1/window/yearCard`)
        .then((res) => {
          this.list = res.yearCard;
          this.tourist_certificate = res.tourist_certificate;
          this.pay_type = res.pay_type;
        });
    },
    handleCheck(item) {

      if (item.stock == 0) return this.$message.error('暂无库存')
      this.handleItem = item;
      this.popShow = true;
      this.$nextTick(res => {
        this.resetUser()
      })
    },
    subUser() {
      this.api.getUrl('/api/v1/window/printerStatus').then(res => {
        if (res.status != 1) {
          this.$alert('<strong style="color:#ed2222;">打印机没有连接</strong>', '注意！', {
            dangerouslyUseHTMLString: true,
            showClose: false
          });
        } else if (res.status == 1) {
          this.$refs["ticketForm"].validate(valid => {
            if (valid) {
              this.loading = this.$loading({
                lock: true,
                background: 'rgba(0, 0, 0, 0.08)',
                text: '正在结算'
              });
              this.orderId = '';
              this.form.year_card_id = this.handleItem.id;
              this.api.postUrl('/api/v1/window/yearCard/submit', this.form).then(res => {
                this.orderId = res.id;
                this.loading.close();
                if (this.form.payment_type == 'ruralCreditPay') { //农信
                  this.payPop = true;
                  this.auth_code = ''
                  this.$nextTick(() => {
                    this.$refs.myInput.focus(); // 确保 DOM 渲染完成后再聚焦
                  });
                } else { //现金
                  this.payFn()
                }
              }, () => {
                this.loading.close();
              })
            }
          });
        }
      })


    },
    resetUser() {
      this.form = {
        contacts: '',
        contact_mobile: '',
        notes: '',
        year_card_id: '',
        tourist_name: '',
        tourist_phone: '',
        tourist_certificate: Object.keys(this.tourist_certificate)[0],
        tourist_code: '',
        payment_type: this.pay_type[0].key
      }
      this.zhaoling = '';
      this.payMoney = '';
      this.$refs['ticketForm'].resetFields();
    },
    payFn(type) {
      this.loading = this.$loading({
        lock: true,
        background: 'rgba(0, 0, 0, 0.08)',
        text: '正在结算'
      });
      this.api.postUrl(`/api/v1/window/yearCard/pay/${this.orderId}`, { auth_code: this.auth_code }).then(res => {
        if (!type) {
          this.$message.success('支付成功')
          this.getList()
          this.loading.close();
          this.popShow = false;
        } else { //农信
          this.timeFlag = 0
          this.timer = setInterval(() => {
            this.timeFlag++;
            this.payType() //查询支付状态
          }, 1000);
        }
      }, () => {
        this.loading.close();
        this.$refs.myInput.focus();
        this.auth_code = '';
      })
    },
    payType() {
      this.api.getUrl(`/api/v1/window/yearCard/getOrderStatus/${this.orderId}`, { auth_code: this.auth_code }).then(res => {
        this.statusFn(res, 1)
      }, () => {
        console.log('支付失败');
        clearInterval(this.timer);
        this.loading.close();
      })
    },
    checkPayStatus() {
      this.nxCheckPopLoading = true;
      this.api.getUrl(`/api/v1/window/yearCard/select/pay/${this.orderId}`, { auth_code: this.auth_code }).then(res => {
        this.statusFn(res, 2)
      })
    },
    statusFn(res, type) {//type-1 系统查询状态 2-手动点击查询状态
      if (type == 2) this.nxCheckPopLoading = false;
      if (res.status == 9) {
        this.$message.error('支付失败，请重新扫码支付')
        clearInterval(this.timer);
        this.auth_code = '';
        this.loading.close();
        this.$refs.myInput.focus();
        this.nxCheckPop = false;
      } else if (res.status == 1) {
        this.$message.success('支付成功')
        this.getList()
        this.loading.close();
        clearInterval(this.timer);
        this.payPop = false;
        this.popShow = false;
        this.nxCheckPop = false;
      } else if (res.status == 0) {//待支付
        if (type == 1) {
          if (this.timeFlag == showZzToast) {
            this.nxCheckPop = true;//打开自助查询弹窗
          }
        } else {
          this.$message('正在支付，请稍后')
        }
      }
    },
    clearCode() {
      this.auth_code = '';
      this.$refs.myInput.focus();
    }
  },
  created() {
    this.query = this.$route.query;
    this.getList()
  },
};
</script>
<style scoped>
.f-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px 0;
  width: 200px;
  height: 100px;
  margin-right: 20px;
  display: inline-flex;
  flex-direction: column;
  /* height: 100px; */
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.f-box .content {
  position: absolute;
  bottom: 0;
  margin-bottom: 10px;
  width: 100%;
}

.mask {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background: #eee; */
}
</style>
